import React from "react";
import videoSaved from "../../../../assets/images/upload/videoSaved.svg";
import { Paper, Typography } from "@mui/material";
import "./videoSavedSuccessfully.scss";
import { pageLocale } from "../../../../utlis/locale";

const VideoSavedSuccessfully = ({ statusVal, styleChange }) => {
  const moduleInfo = JSON.parse(sessionStorage.getItem("fromUpload") || "");
  const { video_saved, recommendation, upload_now } = pageLocale("videoUpload");
  const uploadNowHandler = () => {
    statusVal(1);
  };
  return (
    <div className="video-saved-success-main-wrapper">
      {!styleChange && (
        <Typography className="title">{moduleInfo?.moduleName}</Typography>
      )}
      <Paper elevation={3} className={`video-saved-success-wrapper`}>
        <img src={videoSaved} alt="filesave" className="video-save-img" />
        <Typography className="saved-text">{video_saved}</Typography>
        <Typography className="recommmend-text">{recommendation}</Typography>
        <button onClick={() => uploadNowHandler()} className="common-btn">
          {upload_now}
        </button>
      </Paper>
    </div>
  );
};

export default VideoSavedSuccessfully;
